import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { map, catchError } from 'rxjs/operators';
import * as Stomp from 'stompjs';
import * as SockJS from 'sockjs-client';

import { Socket } from '../service/socket'
import {Subject} from "rxjs/Subject";

declare var io : {
  connect(url: string): Socket;
};

@Injectable()
export class WebSocketService {

  observer: Observer<string>;
  private stompClient = null;
  sendResult = new Subject<string>();

  getApiData() {
    //const socket = new SockJS('http://localhost:8080/candlestick-endpoint/');
    const socket = new SockJS('https://test8319.herokuapp.com/candlestick-endpoint/');
    this.stompClient = Stomp.over(socket);
    this.stompClient.connect("guest", "guest", this.connectCallback.bind(this), this.errorCallback);
    return this.sendResult;
  }

  errorCallback() {
    alert("!!!");
  };

  connectCallback(): Observable<string> {

    this.stompClient.subscribe('/topic/candlestick', (res) => {
      if (res.body) {
        this.sendResult.next(res.body);
      }
    })
    return this.sendResult.asObservable();
    /*this.stompClient.subscribe('/topic/candlestick', (res) => {
      message:Subject<string> = new Subject();

              this.message.next(res.body);

      console.log(res.body);
    });*/

  }

  sendMessage(message){
    this.stompClient.send("/candlestick" , {}, message);
  }


  private handleError(error) {
    console.error('server error:', error);
    if (error.error instanceof Error) {
      let errMessage = error.error.message;
      return Observable.throw(errMessage);
    }
    return Observable.throw(error || 'Socket.io server error');
  }
}



// WEBPACK FOOTER //
// ./src/app/service/web-socket.service.ts